<template>
  <div class="menu-nav">
    <ul class="menu-nav__list">
      <li
        v-for="(page, index) in pages"
        :key="index"
        class="menu-nav__item"
      >
        <Component
          :is="page.soon ? 'div' : 'NuxtLink'"
          v-tooltip="page.tooltip ? {
            text: page.tooltip,
            top: true,
            left: !(index % 2),
            right: index % 2 === 1 || index === 0,
            trigger: 'click',
            timeOut: 5000,
          } : null"
          class="menu-nav__link"
          :class="{
            'snow': page.snow,
            'soon': page.soon
          }"
          exact-active-class="active"
          :disabled="page.disabled"
          :to="page.path"
        >
          <img :src="page.img" alt="nav-item-image" class="menu-nav__image" />
          <div class="menu-nav__text">
            <div v-if="page.dot" class="menu-nav__dot" />
            <UiText
              tag="span"
              class=""
              font="promo-heading-3"
              color="typography-title02"
              :text="page.title"
            />
          </div>
          <div v-if="page.update" class="menu-nav__notification" />
          <UiBadge
            v-if="page.new"
            class="menu-nav__badge"
            background="light"
            type="secondary"
            size="small"
            :text="page.badgeText"
          />
          <UiBadge
            v-if="page.soon"
            class="menu-nav__badge"
            background="solid"
            type="light"
            size="small"
            text="Скоро"
          />
        </Component>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MenuNav',
  computed: {
    pages() {
      return [
        {
          ...this.$pathObj.slots,
          img: '/img/navigation/slots.webp',
        },
        {
          img: '/img/navigation/sport.webp',
          title: 'спорт',
          soon: true,
          tooltip: this.$t('burgerMenu.tooltip'),
        },
        {
          ...this.$pathObj.live,
          img: '/img/navigation/live.webp',
          dot: true,
        },
        {
          ...this.$pathObj.providers,
          img: '/img/navigation/providers.webp',
        },
        {
          title: this.$i18n.locale === 'ua' ? 'Турніри' : 'Турниры',
          img: '/img/navigation/tournaments.webp',
          disabled: true,
          soon: true,
          tooltip: this.$t('burgerMenu.tooltip'),
        },
        {
          ...this.$pathObj.bonusList,
          img: '/img/navigation/promotions.webp',
        },
        // {
        //   title: this.$i18n.locale === 'ua' ? 'Розіграші' : 'Розыгрыши',
        //   img: '/img/navigation/raffles.webp',
        //   disabled: true,
        //   soon: true,
        //   tooltip: this.$t('burgerMenu.tooltip'),
        // },
      ]
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
